import { authenticatedFastApiAxiosInstance as api } from "@/lib/data/http";
import { mailIntakeListSchema } from "@/lib/data/schemas/mail-intake";

export const retrieveMailIntake = async (batchId?: string, cursor?: string) =>
  mailIntakeListSchema.parse(
    (
      await api.get("files/intake", {
        params: { intakeBatchId: batchId, cursor, limit: 100 },
      })
    ).data,
  );
